import { productApi, TagTypes } from 'Services/ProductManagement/Features/Product/productApi'
import { useUpdateSingleTariffMutation } from 'Services/ProductManagement/Features/Tariff/tariffApi'
import { useAppDispatch } from 'Store'
import { RTKCacheTags } from 'Util/constants'

export default function useUpdateTariffProducts() {
  const dispatch = useAppDispatch()
  const [updateSingleTariff, state] = useUpdateSingleTariffMutation()

  const updateTariff: typeof updateSingleTariff = (...args) => {
    const result = updateSingleTariff(...args)
    result.unwrap().then(() => {
      dispatch(
        productApi.util.invalidateTags([
          { type: TagTypes.PRODUCT, id: RTKCacheTags.LIST },
          { type: TagTypes.PRODUCT, id: RTKCacheTags.LIST_ALL }
        ])
      )
    })
    return result
  }

  return [updateTariff, state] as const
}
